import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sh_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && !window.location.pathname.includes("/login")) {
      localStorage.removeItem("sh_token");
      localStorage.removeItem("sh_user");
      const role = localStorage.getItem("sh_role") || "admin";
      window.location.href = `/${role}/login`;
    }
    return Promise.reject(err);
  }
);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return "—"; }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return "—"; }
};

export const fmtRelative = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff/60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff/3600)}h ago`;
  return fmtDate(iso);
};

export const fmtDuration = (seconds) => {
  if (!seconds) return "0m";
  const h = Math.floor(seconds/3600);
  const m = Math.floor((seconds%3600)/60);
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
};

export const STATUS_COLORS = {
  "New Lead":   { bg: "#EFF6FF", text: "#2563EB", border: "#BFDBFE", col: "#3B82F6" },
  "Contacted":  { bg: "#F5F3FF", text: "#7C3AED", border: "#DDD6FE", col: "#8B5CF6" },
  "Quote Sent": { bg: "#FFFBEB", text: "#B45309", border: "#FDE68A", col: "#F59E0B" },
  "Follow-up":  { bg: "#FEFCE8", text: "#CA8A04", border: "#FEF08A", col: "#EAB308" },
  "Booked":     { bg: "#F0FDF4", text: "#16A34A", border: "#BBF7D0", col: "#22C55E" },
  "Lost":       { bg: "#FEF2F2", text: "#DC2626", border: "#FECACA", col: "#EF4444" },
};
